import query from './query';

export const searchTile = {
  query
}


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/config/endpoints/searchtile/index.js